/* @flow */
import * as React from 'react';

import Styled from './styled';
import ErrorAwareImage from '../ErrorAwareImage';

type Props = {
  title?: string | React$Element<any>,
  subtitle?: string | React$Element<any>,
  details?: string | React$Element<any>,
  description?: string,
  imageSrc?: string,
  children?: any,
};

export default (props: Props) => {
  const { title, subtitle, details, description, imageSrc, children } = props;
  return (
    <Styled.Container>
      <Styled.CoverColumn>
        <ErrorAwareImage size={'xl'} src={imageSrc} alt={'Cover'} />
        {details && <div>{details}</div>}
      </Styled.CoverColumn>
      <Styled.DescriptionColumn>
        {title && <h2>{title}</h2>}
        {subtitle && <h3>{subtitle}</h3>}
        {description &&
          description
            .split('\n')
            .map((paragraph, index) => (
              <p key={`${index}_${paragraph.substring(0, 5)}`}>{paragraph}</p>
            ))}
        {children}
      </Styled.DescriptionColumn>
    </Styled.Container>
  );
};
